<!-- Button cta do DS -->
<button type="button" class="oa-btn oa-btn--cta" (click)="open()">
    <ng-content></ng-content>
</button>
